/* unplugin-vue-components disabled */import { render } from "./fzsanfangqixiang.vue?vue&type=template&id=7af95a86&scoped=true"
import script from "./fzsanfangqixiang.vue?vue&type=script&lang=js"
export * from "./fzsanfangqixiang.vue?vue&type=script&lang=js"

import "./fzsanfangqixiang.vue?vue&type=style&index=0&id=7af95a86&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7af95a86"]])

export default __exports__